interface PageSpinnerProps {
  fullScreen?: boolean;
  label?: string;
}

export default function PageSpinner({
  fullScreen = false,
  label = 'Loading...',
}: PageSpinnerProps) {
  return (
    <div
      className={`flex items-center justify-center bg-gray-50 dark:bg-gray-900 ${
        fullScreen ? 'min-h-screen' : 'min-h-[50vh] py-16'
      }`}
    >
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-700 dark:border-green-400 mx-auto mb-4" />
        <p className="text-gray-600 dark:text-gray-400">{label}</p>
      </div>
    </div>
  );
}
